class Yield {
    value;
    constructor(response) {
        this.value = response.value;
    }
    print() {
        return this.value !== undefined ? `${this.value.toString()}%` : '';
    }
}
export default Yield;
